import { css } from "@emotion/css";
const appStyles = {
	page: css`
		height: 100vh;
		overflow-y: auto;
		.container {
			width: 100%;
			margin: 0 auto;
			padding: 0 16px;
		}
	`,
	textYellowGradient: css`
		background: linear-gradient(to bottom, #fff9d7 0%, #fbae3d 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	`,
	header: css`
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 14px 0;
		.logo {
			display: flex;
			align-items: center;
			gap: 34px;
			background: rgba(57, 68, 110, 0.6);
			padding: 8px 20px;
			border-radius: 40px;
			img {
				width: 150px;
			}
			h6 {
				color: #ffc672;
			}
		}
		.btn-exit {
			display: flex;
			align-items: center;
			gap: 16px;
			border: 1px solid #ff0000;
			padding: 10px 26px;
			border-radius: 40px;
			background: #2b0808;
			img {
				width: 24px;
			}
			span {
				color: #ffb677;
				font-weight: 600;
			}
		}
	`,
	body: css`
		padding-top: 28px;
		border-top: 1px solid #e28800;
		.body-top {
			display: flex;
			gap: 16px;
			.user-info {
				flex: 1;
				border: 1px solid #454c7c;
				border-radius: 8px;
				padding: 12px;
				background: #080b21;
			}
			.info-1 {
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1px solid #454c7c;
				padding-bottom: 12px;
				.btn-history {
					background: linear-gradient(180deg, rgba(255, 249, 215, 1) 0%, rgba(242, 215, 162, 1) 50%, rgba(251, 174, 61, 1) 100%);
					border-radius: 8px;
					padding: 1px;
					cursor: pointer;
					.button-inner {
						display: flex;
						align-items: center;
						gap: 4px;
						background: linear-gradient(180deg, rgba(105, 16, 232, 1) 0%, rgba(55, 4, 97, 1) 100%);
						border-radius: 8px;
						border: 2px solid #000;
						padding: 6px 4px;
						img {
							width: 24px;
						}
						span {
							color: #fff;
							font-size: 14px;
						}
					}
				}
			}
			.info-2 {
				padding-top: 16px;
				.balance {
					display: flex;
					align-items: center;
					gap: 8px;
					background: #141d33;
					padding: 8px;
					border-radius: 8px;
					img {
						width: 18px;
					}
				}
			}
		}
		.tab-list {
			display: flex;
			gap: 24px;
			background: rgba(8, 11, 33, 0.5);
			border-radius: 8px;
			padding: 12px 14px;
			margin: 12px 0;
			.tab-item {
				flex: 0 0 166px;
				width: 166px;
				text-align: center;
				background: linear-gradient(180deg, rgba(255, 249, 215, 1) 0%, rgba(242, 215, 162, 1) 50%, rgba(251, 174, 61, 1) 100%);
				border: 1px solid transparent;
				border-radius: 8px;
				cursor: pointer;
				.tab-item-inner {
					overflow: hidden;
					padding: 8px 0;
					background: rgba(8, 11, 33, 1);
					border-radius: 7px;
					border: 1px solid transparent;
					position: relative;
					p {
						font-size: 20px;
					}
					.label-new {
						position: absolute;
						top: -12px;
						right: -26px;
						color: #dd0104;
						background: #fff;
						padding: 20px 20px 4px;
						transform: rotate(45deg);
						font-size: 10px;
						font-weight: 700;
					}
					.label-comming {
						position: absolute;
						right: -4px;
						top: -10px;
						font-size: 10px;
						padding: 2px 4px;
						border-radius: 4px;
						background: linear-gradient(180deg, rgba(11, 117, 121, 1) 0%, rgba(2, 46, 42, 1) 100%);
					}
					&.comming {
						overflow: initial;
					}
				}
				&.active {
					.tab-item-inner {
						border: 1px solid rgba(8, 11, 33, 1);
						background: linear-gradient(180deg, rgba(251, 0, 4, 1) 0%, rgba(110, 0, 2, 1) 100%);
					}
				}
			}
		}
		.game-list {
			display: flex;
			flex-wrap: wrap;
			gap: 24px;
		}
	`,
	bannerSlide: css`
		flex: 0 0 75%;
		max-width: 75%;
		border: 1px solid #454c7c;
		border-radius: 8px;
		overflow: hidden;
		.banner-image {
			width: 100%;
			display: flex;
		}
		.swiper {
			width: 100%;
			height: 100%;
			.swiper-wrapper {
				.swiper-slide {
					img {
						width: 100%;
						height: 100%;
						object-fit: fill;
					}
				}
			}
		}
	`,
};

export default appStyles;
